<template>
    <div cols="12" class="neu-card-questions-and-answers">
        <div class="my-auto">
            <h3 v-html="question"></h3>
            <b-row class="mt-4 justify-center">
                <b-col cols="10" sm="6" lg="3" v-if="answers.length === 0">
                    <base-input :disabled="readOnly" :value="healthVarValue" zeroMarginBottom :type="inputType" :min="0" class="form-group" @input="$emit('inputSelected', $event)" :placeholder="$t('value')"><template v-if="VAR_UNITS[answerVarName]" #append>{{ VAR_UNITS[answerVarName] }}</template></base-input>
                </b-col>
                <clinic-history-quiz-answer :readOnly="readOnly" v-if="answers.length" v-for="item in answers" :key="`${$i18nHelpers.normalize(item.name)}-${item.answerId}`" :quizAnswersColumnsAnchor="quizAnswersColumnsAnchor" @elementSelected="$emit('elementSelected', {answerId: item.answerId, clinicHistoryValue: item.clinicHistoryValue})" :id="item.answerId" :answer="$i18nHelpers.normalize(item.name)" :answersSelected="answersSelected"></clinic-history-quiz-answer>
                <clinic-history-quiz-answer v-if="showDontKnowAnswer && !readOnly" @elementSelected="$emit('elementSelected', {answerId: defaultAnswer.id, emptyValue: true})" :id="defaultAnswer.id" :answer="defaultAnswer.name" :answersSelected="answersSelected"></clinic-history-quiz-answer>
            </b-row>
        </div>
    </div>
</template>

<script>
import BaseInput from '@/components/base/forms/BaseInput'
import ClinicHistoryQuizAnswer from '@/components/views/clinicHistory/quiz/ClinicHistoryQuizAnswer'
import { VAR_UNITS } from '@/constants/clinicHistory'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'

export default {
    components: {
        BaseInput,
        ClinicHistoryQuizAnswer
    },
    props: {
        question: {
            type: String,
            required: true
        },
        questionId: String,
        answers: Array,
        answerVarName: String,
        inputType: {
            type: String,
            default () {
                return 'number'
            }
        },
        healthVarValue: [String, Number],
        answersSelected: [Array],
        quizAnswersColumnsAnchor: Number,
        showDontKnowAnswer: Boolean,
        isCompleted: Boolean,
        dontKnowAnswerTitle: {
            type: String,
            default () {
                return this.$t('dontKnow')
            }
        }
    },
    mixins: [clinicHistoryMixin],
    data () {
        return {
            defaultAnswer: {
                id: `${this.questionId}-answer`,
                name: this.dontKnowAnswerTitle,
                value: null
            },
            VAR_UNITS
        }
    },
    created () {
        if (this.isCompleted && ((this.answers.length > 0 && this.answersSelected.length === 0) || (this.answers.length === 0 && !this.healthVarValue))) {
            this.$emit('elementSelected', {answerId: this.defaultAnswer.id, emptyValue: true})
        }
    },
    methods: {
    },
    computed: {
        readOnly () {
            return !this.$store.getters['session/userIsPatient'] || this.historyReadOnly
        }
    }
}
</script>

<style lang="scss" scoped>
.neu-card-questions-and-answers{
  box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);
  border: 1px solid $white;
  border-radius: 23px;
  display: block;
  background-color: $white;
  -webkit-transition: all .5s ease;
  transition: all .5s ease;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  padding: 2rem;
  margin-bottom: 2rem;
}
.justify-center{
    justify-content: center;
}
.quiz-answer-selected{
    background-color: $green;
}
</style>



// WEBPACK FOOTER //
// src/components/views/clinicHistory/quiz/ClinicHistoryQuizForm.vue